import { NativeBaseProvider } from "native-base";
import { Home } from "./src/screens/Home";
import { Routes } from "./src/routes";

export default function App() {
  return (
    <NativeBaseProvider>
      <Routes />
    </NativeBaseProvider>
  );
}
